export const APP_NAME = 'appName'

export const WECHAT_REDIRECT =
  'https://rivers.chaitin.cn/api/users/auth/wechat/callback'

export const COUNTDOWN_SECONDS = 180
